import { render, staticRenderFns } from "./Metricas.vue?vue&type=template&id=29767d4e&scoped=true"
import script from "./Metricas.vue?vue&type=script&lang=js"
export * from "./Metricas.vue?vue&type=script&lang=js"
import style0 from "./Metricas.vue?vue&type=style&index=0&id=29767d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29767d4e",
  null
  
)

export default component.exports